import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-24 px-4 bg-warmwhite" data-id="element-256" data-mp="2lm0urc5l7auk">
      <div className="max-w-4xl mx-auto" data-id="element-257" data-mp="26yfqhewz75l2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-258" data-mp="26xmt34jwpsfl">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-8" data-id="element-259" data-mp="21zl7ocz0dh0y">
            ¿Te suena conocido esto?
          </h2>
          <div className="bg-white p-8 rounded-2xl border border-cream-dark shadow-sm text-left space-y-4 text-ink text-lg leading-relaxed" data-id="element-260" data-mp="1o1ejjojv2veh">
            <p data-id="element-261" data-mp="3idupspcnq9jc">Es domingo a la tarde.</p>
            <p data-id="element-262" data-mp="3ie4f0apvocnz">
              Mañana tenés práctica de taller y todavía no terminaste de
              preparar la clase.
            </p>
            <p data-id="element-263" data-mp="1z0os8q66nrfr">
              Abrís el buscador. Encontrás un manual europeo que no tiene nada
              que ver con los productos de tu región. Encontrás una receta sin
              parámetros técnicos. Encontrás teoría que no podés trasladar a una
              actividad práctica.
            </p>
            <p data-id="element-264" data-mp="23rdglwmkg8ao">Una hora después, seguís buscando.</p>
            <p data-id="element-265" data-mp="23rx21nbfdetg">
              Armás algo. No es lo que querías, pero va a tener que alcanzar.
            </p>
            <p data-id="element-266" data-mp="1g22qra6r7ybb">Y el lunes siguiente, empezás de nuevo.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-267" data-mp="1b4anxl4kmrsc">
          <h3 className="text-2xl font-bold text-green text-center" data-id="element-268" data-mp="30gmm9kaiyjil">
            Esto es lo que le pasa a la mayoría de los docentes técnicos de
            alimentos:
          </h3>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-269" data-mp="1t5y8wl9qif30">
            {[{
            title: 'Información dispersa',
            desc: 'encontrás teoría en un lugar, procesos en otro, formulaciones en ninguno.'
          }, {
            title: 'Temas desconectados',
            desc: 'enseñás conservación, después embutidos, pero los alumnos no ven la cadena completa.'
          }, {
            title: 'Actividades que hay que inventar',
            desc: 'la teoría existe pero convertirla en práctica de taller lleva horas.'
          }, {
            title: 'Evaluaciones de último momento',
            desc: 'construís el examen el mismo día, con lo que encontrás.'
          }, {
            title: 'Alumnos desconectados',
            desc: 'no entienden para qué sirve medir el pH si nunca ven cómo ese dato afecta el producto real.'
          }, {
            title: 'Fines de semana perdidos',
            desc: 'planificando en lugar de descansar.'
          }].map((point, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white p-6 rounded-xl border-l-4 border-terracota shadow-sm" data-id="element-270" data-mp="e82cyktmnzgp" data-mpi={i}>
                <AlertCircle className="text-terracota shrink-0 mt-1" size={20} data-id="element-271" data-mp="3mp6x8zhemiov" />
                <div data-id="element-272" data-mp="3iod7e0keittc">
                  <span className="font-bold text-ink block mb-1" data-id="element-273" data-mp="3dnft3z2iijx4">
                    {point.title}
                  </span>
                  <span className="text-slate text-sm" data-id="element-274" data-mp="1hjt15alpj39d">{point.desc}</span>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center mt-16 pt-10 border-t border-cream-dark" data-id="element-275" data-mp="1lnh6dmmv9mrg">
            <p className="text-2xl font-serif font-bold text-terracota mb-2" data-id="element-276" data-mp="17tzmg0q9q80w">
              El problema no es tu dedicación. La tenés de sobra.
            </p>
            <p className="text-xl text-green font-medium" data-id="element-277" data-mp="xvsjwmwq7sif">
              El problema es que no tenés el sistema.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}